import { render, staticRenderFns } from "./SubmissionsTable.vue?vue&type=template&id=6fcd19f1&scoped=true&"
import script from "./SubmissionsTable.vue?vue&type=script&lang=js&"
export * from "./SubmissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsTable.vue?vue&type=style&index=0&id=6fcd19f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd19f1",
  null
  
)

export default component.exports